<template>
    <div class="py-14">
        <v-row no-gutters>
            <v-col cols="12" md="7" align-self="center">
                <v-row no-gutters align="center">
                    <v-col cols="3">
                        <bids-item-imgs :imgs="work?.imgs" />
                    </v-col>
                    <v-col cols="9">
                        <div class="pl-16 pl-md-20">
                            <div class="mb-8 mb-md-10">
                                <span class="font-size-14 font-weight-medium primary--text">
                                    {{ work?.auctionCategoryText }}
                                    <span v-if="work?.program?.subject"><span> - </span>{{ work?.program?.subject }}</span>
                                </span>
                            </div>
                            <div class="d-flex flex-wrap align-center">
                                <v-chip outlined small class="rounded-0 mr-8">{{ work?.lot }}</v-chip>
                                <strong class="font-size-16 font-size-md-18">{{ work?.author?.name?.ko }}</strong>
                            </div>
                            <div class="mt-2 mt-md-4">
                                <span class="font-size-14 font-size-md-16">{{ work?.subject }}</span>
                            </div>
                            <div class="mt-8 mt-md-10">
                                <div class="font-size-14 line-height-13 grey-68--text">{{ work?.year }}<br />{{ work?.material }} ㅣ {{ work?.dimensionTag }}</div>
                            </div>
                        </div>
                    </v-col>
                </v-row>

            </v-col>
            <v-col cols="auto" class="d-none d-md-block" style="margin-left:-1px;">
                <v-divider vertical class="grey-da"></v-divider>
            </v-col>
            <v-col cols="12" md="5" align-self="center">
                <div class="font-size-14 py-10 pa-md-20 pl-md-40">
                    <template v-if="isPrivate">
                        <v-btn :to="`/auction-works/${work._id}`" small block color="primary"><span class="font-size-14 font-size-xl-16">문의하기</span></v-btn>
                    </template>

                    <template v-if="isProgram">
                        <template v-if="work.isAuctionEnded">
                            <v-row no-gutters align="baseline">
                                <v-col cols="3">
                                    <span>추정가</span>
                                </v-col>
                                <v-col cols="9">
                                    <div class="grey-68--text pl-sm-12">KRW {{ work?.price_estimated?.from?.format?.() || "0" }} ~ {{ work?.price_estimated?.to?.format?.() || "" }}</div>
                                </v-col>
                            </v-row>
                            <v-row no-gutters align="baseline" class="mt-2 mt-md-4">
                                <v-col cols="3">
                                    <span>시작가</span>
                                </v-col>
                                <v-col cols="9">
                                    <div class="grey-68--text pl-sm-12">KRW {{ work?.price_auction?.from?.format?.() || "0" }}</div>
                                </v-col>
                            </v-row>
                            <v-row no-gutters align="baseline" class="font-weight-medium mt-2 mt-md-4">
                                <v-col cols="3">
                                    <span>낙찰가</span>
                                </v-col>
                                <v-col cols="9">
                                    <div class="pl-sm-12">KRW {{ work?.price_auction?.current?.format?.() || "0" }}</div>
                                </v-col>
                            </v-row>
                            <div class="mt-10 mt-md-16">
                                <v-btn :to="`/auction-works/${work._id}`" small block outlined class="grey-cb--text"><span class="font-size-14 font-size-xl-16 primary--text">상세보기</span></v-btn>
                            </div>
                        </template>

                        <template v-else>
                            <v-row no-gutters align="baseline">
                                <v-col cols="3">
                                    <span>추정가</span>
                                </v-col>
                                <v-col cols="9">
                                    <div class="grey-68--text pl-sm-12">KRW {{ work?.price_estimated?.from?.format?.() || "0" }} ~ {{ work?.price_estimated?.to?.format?.() || "" }}</div>
                                </v-col>
                            </v-row>
                            <v-row no-gutters align="baseline" class="mt-2 mt-md-4">
                                <v-col cols="3">
                                    <span>시작가</span>
                                </v-col>
                                <v-col cols="9">
                                    <div class="grey-68--text pl-sm-12">KRW {{ work?.price_auction?.from?.format?.() || "0" }}</div>
                                </v-col>
                            </v-row>
                            <v-row no-gutters align="baseline" class="font-weight-medium mt-2 mt-md-4">
                                <v-col cols="3">
                                    <span>현재가</span>
                                </v-col>
                                <v-col cols="9">
                                    <div class="pl-sm-12">KRW {{ work?.price_auction?.current?.format?.() || "0" }}</div>
                                </v-col>
                            </v-row>
                            <div class="mt-10 mt-md-16">
                                <v-btn :to="`/auction-works/${work._id}`" small block color="primary"><span class="font-size-14 font-size-xl-16">응찰하기</span></v-btn>
                            </div>
                        </template>
                    </template>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { WORK_AUCTION_MODES } from "@/assets/variables";
import BidsItemImgs from "../mypage/bids-item-imgs.vue";

export default {
    components: { BidsItemImgs },
    props: {
        work: { type: Object, default: () => ({}) },
    },
    computed: {
        isPrivate() {
            return this.work.mode_auction == WORK_AUCTION_MODES.PRIVATE.value;
        },
        isProgram() {
            return this.work.mode_auction == WORK_AUCTION_MODES.PROGRAM.value;
        },
    },
};
</script>

<style></style>
